import CrmServiceModel from "@/models/CrmServiceModel"

export default class CustomerCoordModel extends CrmServiceModel {

  modelName() {
    return 'customer-coords';
  }

  publicRoutes() {
    let routes = super.publicRoutes() || {};
    routes.create = process.env.VUE_APP_CRM_REPOSITORY_URL + '/api/v1/' + this.modelName();
    routes.exists = process.env.VUE_APP_CRM_REPOSITORY_URL + '/api/v1/' + this.modelName() + '/exists';
    return routes;
  }

  defaults () {
    return {
      id: null,
      customer_id: null,
      customer_field_id: null,
      name: null,
      lat: null,
      long: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
    }
  }

  nullLatLongMutator(val) {
    const num = _.isNull(val) ? null : _.toNumber(val);
    if (_.isFinite(num)) {
      return num.toFixed(6);
    }
    return null;
  }

  // Attribute mutations.
  mutations () {
    return {
      id: (val) => (this.nullStringMutator(val)),
      customer_id: (val) => (this.nullStringMutator(val)),
      customer_field_id: (val) => (this.nullStringMutator(val)),
      name: (val) => (this.nullStringMutator(val)),
      lat: (val) => (this.nullLatLongMutator(val)),
      long: (val) => (this.nullLatLongMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val))
    }
  }

}
